var _path, _path2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 484,
    viewBox: "0 0 345 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.571 32.8708C2.571 15.1977 16.8979 0.870852 34.571 0.870852L312.571 0.87085C330.244 0.87085 344.571 15.1977 344.571 32.8708L344.571 448.871C344.571 466.544 330.244 480.871 312.571 480.871L34.571 480.871C16.8979 480.871 2.571 466.544 2.571 448.871L2.571 32.8708Z",
    fill: "url(#paint0_linear_52_306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97333 34.1526C1.97333 16.4795 16.3002 2.15256 33.9733 2.15256L311.973 2.15256C329.646 2.15256 343.973 16.4795 343.973 34.1526V450.153C343.973 467.826 329.646 482.153 311.973 482.153L33.9733 482.153C16.3002 482.153 1.97333 467.826 1.97333 450.153L1.97333 34.1526Z",
    fill: "url(#paint1_linear_52_306)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.772156,
    y: 3.01172,
    width: 342,
    height: 480,
    rx: 32,
    fill: "#3079FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_306",
    x1: 79.0437,
    y1: -17.3789,
    x2: 267.501,
    y2: 500.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_306",
    x1: 79.0437,
    y1: -17.3789,
    x2: 267.501,
    y2: 500.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDark);
export default __webpack_public_path__ + "static/media/CardDark.73dffa3a45581a1099514cc000593844.svg";
export { ForwardRef as ReactComponent };